import { baseUrl } from "../../../config/url-config/index";
import axiosInstance from "../axiosInstance";

const Post = async (path, data) => {
  const result = await axiosInstance.post(`${baseUrl}/${path}`, data);
  return result;
};

export default Post;
